import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";

const config = {
    apiKey: "AIzaSyB7yROaHSbx2w91jSJucC4a4ha-SVeGWd4",
    authDomain: "diary-bc71a.firebaseapp.com",
    databaseURL: "https://diary-bc71a.firebaseio.com",
    projectId: "diary-bc71a",
    storageBucket: "diary-bc71a.appspot.com",
    messagingSenderId: "812456674134",
    appId: "1:812456674134:web:0ecc97a6457fc7d5"
  };

  export default {
    init() {
        firebase.initializeApp(config);
    }
  }